<template>
  <div
    v-if="ready"
    class="modal is-active"
  >
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ year }} {{ filingStatus }} Redaction
        </p>
        <button
          id="modal-close-btn"
          type="button"
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        />
      </header>
      <section class="modal-card-body">
        <p class="subtitle">
          Select the forms to be redacted and the corresponding official's categories.
        </p>
        <table class="table is-fullwidth is-narrow">
          <thead>
            <tr>
              <th>
                <span class="icon has-text-sidewalk">
                  <i class="fal fa-check-square is-size-4" />
                </span>
              </th>
              <th> Form </th>
              <th> Official's Category </th>
              <th> Type </th>
              <th class="has-text-centered">
                Original
              </th>
              <th class="has-text-centered">
                Redacted
              </th>
              <th class="has-text-centered">
                Delete
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="filing.cityForm === 'Y'">
              <td>
                <checkbox
                  v-model="redactCity"
                  :value="true"
                />
              </td>
              <td>
                City
              </td>
              <td>
                <dropdown
                  v-model="cityOfficialsCategory"
                  :options="officialsCategories"
                  value-key="name"
                  text-key="name"
                  default-option="Select Category"
                  placeholder="Select Category"
                />
              </td>
              <td class="has-text-centered">
                {{ filing.filedOffline === 'Y' ? 'paper' : 'electronic' }}
              </td>
              <td class="has-text-centered">
                <template v-if="filing.filedOffline === 'Y'">
                  <a
                    v-if="filing.cityUrl"
                    :href="filing.cityUrl"
                    target="_blank"
                    class="is-small"
                  >
                    <span class="icon has-text-secondary is-size-4">
                      <i class="fas fa-file-pdf" />
                    </span>
                  </a>
                </template>
                <template v-else>
                  <a
                    v-if="filing.cityPdfUrl !== null"
                    :href="filing.cityPdfUrl"
                    target="_blank"
                    class="button icon-btn has-text-primary"
                  >
                    <span class="icon has-text-secondary is-size-4">
                      <i class="fas fa-file-pdf" />
                    </span>
                  </a>
                  <button
                    v-else
                    href="#"
                    target="_blank"
                    class="button icon-btn has-text-primary"
                    :class="isLoadingCityPdf ? 'is-loading' : ''"
                    @click.prevent="genPdfUrl('City', filing.id)"
                  >
                    <span class="icon is-size-4">
                      <i class="fa fa-file-pdf" />
                    </span>
                  </button>
                </template>
              </td>
              <td class="has-text-centered">
                <a
                  v-if="filing.cityRedactedUrl !== null"
                  :href="filing.cityRedactedUrl"
                  target="_blank"
                  class="is-small"
                >
                  <span
                    :class="filing.isCityRedactedPublished === 'Y' ? 'has-text-success' : 'has-text-primary'"
                    class="icon is-size-4"
                  >
                    <i class="fad fa-file-pdf" />
                  </span>
                </a>
                <span v-else>---</span>
              </td>
              <td class="has-text-centered">
                <a
                  v-if="filing.cityRedactedUrl !== null"
                  :href="filing.cityRedactedUrl"
                  target="_blank"
                  class="is-small is-button del-btn"
                  :class="isDeletingCity ? 'is-loading' : ''"
                  @click.prevent="deleteRedactionModal('City')"
                >
                  <span class="icon has-text-danger is-size-4">
                    <i class="fad fa-trash-alt" />
                  </span>
                </a>
                <span v-else>---</span>
              </td>
            </tr>
            <tr v-if="filing.stateForm === 'Y'">
              <td>
                <checkbox
                  v-model="redactState"
                  :value="true"
                />
              </td>
              <td>
                State
              </td>
              <td>
                <dropdown
                  v-model="stateOfficialsCategory"
                  :options="officialsCategories"
                  value-key="name"
                  text-key="name"
                  default-option="Select Category"
                  placeholder="Select Category"
                />
              </td>
              <td class="has-text-centered">
                {{ filing.filedOffline === 'Y' ? 'paper' : 'electronic' }}
              </td>
              <td class="has-text-centered">
                <template v-if="filing.filedOffline === 'Y'">
                  <a
                    v-if="filing.stateUrl !== null"
                    :href="filing.stateUrl"
                    target="_blank"
                    class="is-small"
                  >
                    <span class="icon has-text-secondary is-size-4">
                      <i class="fas fa-file-pdf" />
                    </span>
                  </a>
                </template>
                <template v-else>
                  <a
                    v-if="filing.statePdfUrl !== null"
                    :href="filing.statePdfUrl"
                    target="_blank"
                    class="button icon-btn has-text-primary"
                  >
                    <span class="icon is-size-4">
                      <i class="fa fa-file-pdf" />
                    </span>
                  </a>
                  <button
                    v-else
                    href="#"
                    target="_blank"
                    class="button icon-btn has-text-primary"
                    :class="isLoadingStatePdf ? 'is-loading' : ''"
                    @click.prevent="genPdfUrl('State', filing.id)"
                  >
                    <span class="icon is-size-4">
                      <i class="fa fa-file-pdf" />
                    </span>
                  </button>
                </template>
              </td>
              <td class="has-text-centered">
                <a
                  v-if="filing.stateRedactedUrl !== null"
                  :href="filing.stateRedactedUrl"
                  target="_blank"
                  class="is-small"
                >
                  <span
                    :class="filing.isStateRedactedPublished === 'Y' ? 'has-text-success' : 'has-text-primary'"
                    class="icon is-size-4"
                  >
                    <i class="fad fa-file-pdf" />
                  </span>
                </a>
                <span v-else>---</span>
              </td>
              <td class="has-text-centered">
                <a
                  v-if="filing.stateRedactedUrl !== null"
                  :href="filing.stateRedactedUrl"
                  target="_blank"
                  class="is-small is-button del-btn"
                  :class="isDeletingState ? 'is-loading' : ''"
                  @click.prevent="deleteRedactionModal('State')"
                >
                  <span class="icon has-text-danger is-size-4">
                    <i class="fad fa-trash-alt" />
                  </span>
                </a>
                <span v-else>---</span>
              </td>
            </tr>
            <tr v-if="filing.mayorForm === 'Y'">
              <td>
                <checkbox
                  v-model="redactMayor"
                  :value="true"
                />
              </td>
              <td>
                Mayor
              </td>
              <td>
                <dropdown
                  v-model="mayorOfficialsCategory"
                  :options="officialsCategories"
                  value-key="name"
                  text-key="name"
                  default-option="Select Category"
                  placeholder="Select Category"
                />
              </td>
              <td class="has-text-centered">
                {{ filing.filedOffline === 'Y' ? 'paper' : 'electronic' }}
              </td>
              <td class="has-text-centered">
                <template v-if="filing.filedOffline === 'Y'">
                  <a
                    v-if="filing.mayorUrl !== null"
                    :href="filing.mayorUrl"
                    target="_blank"
                    class="is-small"
                  >
                    <span class="icon has-text-secondary is-size-4">
                      <i class="fas fa-file-pdf" />
                    </span>
                  </a>
                </template>
                <template v-else>
                  <a
                    v-if="filing.mayorPdfUrl !== null"
                    :href="filing.mayorPdfUrl"
                    target="_blank"
                    class="button icon-btn has-text-primary"
                  >
                    <span class="icon is-size-4">
                      <i class="fa fa-file-pdf" />
                    </span>
                  </a>
                  <button
                    v-else
                    href="#"
                    target="_blank"
                    class="button icon-btn has-text-primary"
                    :class="isLoadingMayorPdf ? 'is-loading' : ''"
                    @click.prevent="genPdfUrl('Mayor', filing.id)"
                  >
                    <span class="icon is-size-4">
                      <i class="fa fa-file-pdf" />
                    </span>
                  </button>
                </template>
              </td>
              <td class="has-text-centered">
                <a
                  v-if="filing.mayorRedactedUrl !== null"
                  :href="filing.mayorRedactedUrl"
                  target="_blank"
                  class="is-small"
                >

                  <span
                    :class="filing.isMayorRedactedPublished === 'Y' ? 'has-text-success' : 'has-text-primary'"
                    class="icon is-size-4"
                  >
                    <i class="fad fa-file-pdf" />
                  </span>
                </a>
                <span v-else>---</span>
              </td>
              <td class="has-text-centered">
                <a
                  v-if="filing.mayorRedactedUrl !== null"
                  :href="filing.mayorRedactedUrl"
                  target="_blank"
                  class="is-small is-button del-btn"
                  :class="isDeletingMayor ? 'is-loading' : ''"
                  @click.prevent="deleteRedactionModal('Mayor')"
                >
                  <span class="icon has-text-danger is-size-4">
                    <i class="fad fa-trash-alt" />
                  </span>
                </a>
                <span v-else>---</span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td
                colspan="7"
                class="is-size-7"
              >
                <span><sup>*</sup></span>
                <span class="icon has-text-success is-size-6">
                  <i class="fad fa-file-pdf" />
                </span>
                <span>Published without redaction.</span>
              </td>
            </tr>
          </tfoot>
        </table>
        <div
          v-if="hasBeenRedacted.check"
          class="message is-warning"
        >
          <div class="message-body">
            Attention: the <b>{{ hasBeenRedacted.formsString }}</b> form{{ hasBeenRedacted.plural ? `s` : `` }} {{ hasBeenRedacted.plural ? `have` : `has` }} already been redacted. A new upload will overwrite the existing file{{ hasBeenRedacted.plural ? `s` : `` }}.
          </div>
        </div>
        <div class="tabs is-boxed">
          <ul>
            <li
              v-if="!wasFiledOffline"
              :class="redactionType === 'ElectronicRedaction' && !wasFiledOffline ? 'is-active' : ''"
            >
              <a @click.prevent="redactionType='ElectronicRedaction'">Electronic Redaction</a>
            </li>
            <li :class="redactionType === 'PaperRedaction' || wasFiledOffline ? 'is-active' : ''">
              <a @click.prevent="redactionType='PaperRedaction'">Paper Redaction</a>
            </li>
            <li
              v-if="!wasFiledOffline"
              :class="redactionType === 'PublishOnly' && !wasFiledOffline ? 'is-active' : ''"
            >
              <a @click.prevent="redactionType='PublishOnly'">Publish Only</a>
            </li>
          </ul>
        </div>
        <div class="columns">
          <div class="column">
            <component
              :is="redactionType"
              :filing-id="filingId"
              :filing="filing"
              :redact-city="redactCity"
              :redact-state="redactState"
              :redact-mayor="redactMayor"
              :city-officials-category="cityOfficialsCategory"
              :state-officials-category="stateOfficialsCategory"
              :mayor-officials-category="mayorOfficialsCategory"
              @redactionCompleted="fetchFiling"
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import Checkbox from '@/components/phila-ui/CheckboxAdv';
import { Dropdown } from '@phila/phila-ui';
import DeleteRedaction from '@/modals/DeleteRedaction';
import { pdfData } from '@/mixins/pdfData';

export default {
  name: 'Redactions',
  components: {
    Checkbox,
    Dropdown,
    'ElectronicRedaction': () => import('@/components/ElectronicRedactions'),
    'PaperRedaction': () => import('@/components/PaperRedactions'),
    'PublishOnly': () => import('@/components/PublishFiling'),
  },
  mixins: [
    pdfData,
  ],
  props: {
    year: {
      type: String,
      required: true,
    },
    filingId: {
      type: Number,
      required: true,
    },
    filingStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoadingCityPdf: false,
      isLoadingStatePdf: false,
      isLoadingMayorPdf: false,
      redactionType: '',
      redactCity: false,
      redactState: false,
      redactMayor: false,
      mayorOfficialsCategory: '',
      cityOfficialsCategory: '',
      stateOfficialsCategory: '',
      officialsCategories: [
        {
          name: 'Elected Officials',
        },
        {
          name: 'Senior Administration Officials',
        },
        {
          name: 'Board & Commission Members',
        },
      ],
      isSaving: false,
      isDeletingCity: false,
      isDeletingState: false,
      isDeletingMayor: false,
      ready: false,
    };
  },
  computed: {
    filing () {
      return this.$store.state.filing.filing;
    },
    hasBeenRedacted() {
      let forms = [];
      if (this.filing.cityForm === 'Y' && this.filing.cityRedactedUrl && this.filing.cityRedactedUrl !== '') {
        forms.push('city');
      }
      if (this.filing.stateForm === 'Y' && this.filing.stateRedactedUrl && this.filing.stateRedactedUrl !== '') {
        forms.push('state');
      }
      if (this.filing.mayorForm === 'Y' && this.filing.mayorRedactedUrl && this.filing.mayorRedactedUrl !== '') {
        forms.push('mayor');
      }

      let lastForm = '';
      if (forms.length > 1) {
        lastForm = forms.pop();
      }

      let plural = lastForm !== '' ? true : false;

      return {
        check: forms.length > 0 ? true : false,
        forms,
        formsString: plural ? `${forms.join(', ')} and ${lastForm}` : forms[0],
        plural,
      };
    },
    wasFiledOffline () {
      return this.filing && this.filing.filedOffline === 'Y' ? true : false;
    },
  },
  watch: {
    wasFiledOffline (newValue) {
      if (newValue === true) {
        this.redactionType = 'PaperRedaction';
      }
    },
  },
  async mounted () {
    await this.initialFetch();
    this.redactionType = (this.filing && this.filing.filedOffline === 'Y') ? 'PaperRedaction' : 'ElectronicRedaction';
    this.ready = true;
  },
  methods: {
    async initialFetch () {
      let promises = [];
      await this.$store.commit('filing/setCurrentFilingId', this.filingId);
      promises.push(await this.$store.dispatch('filing/fetchFiling'));
      await Promise.all(promises);
    },
    async fetchFiling () {
      this.$store.dispatch('filing/fetchFiling');
    },
    async genPdfUrl (type, filingId) {
      this[`isLoading${type}Pdf`] = true;
      let pdfData = await this.pdf_getPdfData(type, filingId);
      let pdfUrl = await this.$store.dispatch('filing/getAdminPdf', pdfData);
      window.open(pdfUrl, "_blank");
      this[`isLoading${type}Pdf`] = false;
    },
    deleteRedactionModal (type) {
      this.$modal.show(DeleteRedaction, {
        type,
      }, {
        classes: [ 'is-small' ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  table.table {
     td, th {
       vertical-align: middle;
       text-align: left;
     }
  }
  .icon-btn {
    background-color: $white;
    border-color: $white;
  }
</style>
